import { render, staticRenderFns } from "./PopularDestinations.vue?vue&type=template&id=383165a2&scoped=true"
import script from "./PopularDestinations.vue?vue&type=script&lang=ts"
export * from "./PopularDestinations.vue?vue&type=script&lang=ts"
import style0 from "./PopularDestinations.vue?vue&type=style&index=0&id=383165a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383165a2",
  null
  
)

export default component.exports